import React from 'react';

const StatusButton = ({ startDate, endDate }) => {
  const currentDate = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  let status = '';
  let backgroundColor = '';
  let borderColor = '';

  if (currentDate < start) {
    status = 'Starting Soon';
    backgroundColor = '#FFA500'; // Orange
    borderColor = '#FFA500';
  } else if (currentDate >= start && currentDate <= end) {
    status = 'In Progress';
    backgroundColor = '#4CAF50'; // Green
    borderColor = '#4CAF50';
  } else {
    status = 'Finished';
    backgroundColor = '#888'; // Gray
    borderColor = '#888';
  }

  const styles = {
    padding: '4px 8px',
    fontSize: '10px',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase',
    cursor: 'not-allowed',
    pointerEvents: 'none',
    borderRadius: '10px',
    border: '1px solid',
    marginLeft: '10px',
    color: '#fff',
    backgroundColor,
    borderColor,
  };

  return <span style={styles}>{status}</span>;
};

export default StatusButton;
